<template>
  <div class="go-to-top" :class="{ 'visible': showButton }" @click="scrollToTop">
    <i class="fas fa-chevron-up"></i>
  </div>
</template>

<script>
export default {
  name: 'GoToTop',
  data() {
    return {
      showButton: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showButton = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
.go-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background-color: #ffffff;
  color: #111855;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: all 0.3s;
  z-index: 999;
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.go-to-top::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #111855, #ffd700);
  opacity: 0;
  transition: opacity 0.3s;
  z-index: -1;
}

.go-to-top.visible {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.go-to-top:hover {
  color: #ffffff;
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
}

.go-to-top:hover::before {
  opacity: 1;
}

.go-to-top i {
  font-size: 18px;
  transition: transform 0.3s;
}

.go-to-top:hover i {
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .go-to-top {
    width: 40px;
    height: 40px;
    bottom: 20px;
    right: 20px;
  }
  
  .go-to-top i {
    font-size: 16px;
  }
}
</style> 